export const locationRoutes = [
  { slug: 'marbella', path: '/stone-carpet-marbella', label: 'Marbella' },
  { slug: 'estepona', path: '/stone-carpet-estepona', label: 'Estepona' },
  { slug: 'benahavis', path: '/stone-carpet-benahavis', label: 'Benahavís' },
  { slug: 'nuevaAndalucia', path: '/stone-carpet-nueva-andalucia', label: 'Nueva Andalucía' },
  { slug: 'mijas', path: '/stone-carpet-mijas', label: 'Mijas' },
  { slug: 'fuengirola', path: '/stone-carpet-fuengirola', label: 'Fuengirola' },
  { slug: 'benalmadena', path: '/stone-carpet-benalmadena', label: 'Benalmádena' },
  { slug: 'torremolinos', path: '/stone-carpet-torremolinos', label: 'Torremolinos' },
  { slug: 'malaga', path: '/stone-carpet-malaga', label: 'Málaga' },
  { slug: 'sotogrande', path: '/stone-carpet-sotogrande', label: 'Sotogrande' },
];
